module.exports = __webpack_public_path__ + "static/media/IMG_20180303_145025.e368e028.webp";